// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashOutlinedSvg from "@ant-design/icons-svg/es/asn/DashOutlined";
import AntdIcon from '../components/AntdIcon';

var DashOutlined = function DashOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashOutlinedSvg
  }));
};

DashOutlined.displayName = 'DashOutlined';
export default React.forwardRef(DashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DashOutlined.js
// module id = 903
// module chunks = 0